import { SyntheticEvent, useEffect, useState } from 'react';
// import { v4 as uuid } from "uuid";
import { observer } from 'mobx-react-lite';
import { metaDataOptions } from '../../../app/common/options/otherOptions/approveOptions';
import { useStore } from '../../../app/stores/store';
import { MetaDataElement } from './../../../app/models/metaDataConfig';
import CommonComponentSettings from '../commonSettings';
import { WorkflowOptions } from '../../../app/models/template';
// import sendRespectiveEmail from "../../../app/models/EmailNew";

interface Props {
  elementsNames: {
    key: string;
    value: string;
    text: string;
  }[];
}

function MetaDataSettings({ elementsNames }: Props) {
  const { metaDataStore, modalStore } = useStore();
  const { selectedMetaDataElem, editSettingsElements, selectedMetaDataET } =
    metaDataStore;
  const [selected, setSelected] = useState<string>('');
  const [elementArr, setElementArr] = useState<MetaDataElement[] | undefined>(
    undefined,
  );
  const [scanType, setScanType] = useState<string>('');

  useEffect(() => {
    if (selectedMetaDataElem.elementType.includes('ScanArea')) {
      setSelected(selectedMetaDataElem.elementType.split('|')[0]);
      setScanType(selectedMetaDataElem.elementType.split('|')[1] || 'Neutral');
    } else if (selectedMetaDataElem.elementType.includes('CurrentUser')) {
      setSelected(selectedMetaDataElem.elementType.split('|')[0]);
    } else {
      setSelected(selectedMetaDataElem.elementType || '');
    }
    // eslint-disable-next-line
  }, [selectedMetaDataElem]);

  useEffect(() => {
    if (selectedMetaDataET !== undefined) {
      setElementArr(selectedMetaDataET.metadata);
    }
    // eslint-disable-next-line
  }, [JSON.stringify(selectedMetaDataET?.metadata || '{}')]);

  const changeSelectOptionHandler = (_e: SyntheticEvent, data: any) => {
    setSelected(data.value);
  };

  const handleSave = (data: {
    value: any;
    isReadOnly: boolean;
    isMandatory: boolean;
    enableByDefault: boolean;
    parentId: string;
    optionsState: WorkflowOptions[];
    validation?: string;
    isMultiple?: boolean;
    metadatatype?: string;
    selectMasterComponent?: string;
    scanAreaType?: string;
    autoPopulate: string;
    metadataFromParent?: string;
  }) => {
    let {
      value,
      isReadOnly,
      isMandatory,
      isMultiple,
      enableByDefault,
      parentId,
      optionsState,
      validation,
      metadatatype,
      selectMasterComponent,
      scanAreaType,
      autoPopulate,
      metadataFromParent,
    } = data || {};
    let copySelectedElement = Object.assign({}, selectedMetaDataElem);

    if (!copySelectedElement) return;

    let tempElementType = '';
    switch (selected) {
      case 'ScanArea':
        tempElementType = selected
          .concat('|')
          .concat(scanAreaType || 'Neutral');
        break;
      case 'CurrentUser':
        tempElementType = selected.concat('|').concat(autoPopulate);
        break;
      default:
        tempElementType = selected;
        break;
    }

    copySelectedElement = {
      ...copySelectedElement,
      elementType: tempElementType,
      readOnly: isReadOnly,
      isMandatory,
      enableByDefault,
      parentId,
      options: [],
      elementValue: value,
      isMultiple: !!isMultiple,
      metadatatype: metadatatype || '',
      selectMasterComponent: selectMasterComponent || '',
      metadataFromParent: metadataFromParent || '',
    };

    if (
      selected === 'DropDown' ||
      selected === 'DynamicTable' ||
      selected === 'dropdownWithTab' ||
      selected === 'tab' ||
      selected === 'Checkbox'
    ) {
      copySelectedElement = {
        ...copySelectedElement,
        isMultiple: !!isMultiple,
        validation: validation || '',
        options: optionsState,
      };
    } else {
      ///for Barcode
      // const BC1 =
      //   workflowConfigurationStore.WorkflowConfiguration.barcodeValue1 === ""
      //     ? ""
      //     : "-" +
      //       workflowConfigurationStore.WorkflowConfiguration.barcodeValue1;
      // const BC2 =
      //   workflowConfigurationStore.WorkflowConfiguration.barcodeValue2 === ""
      //     ? ""
      //     : "-" +
      //       workflowConfigurationStore.WorkflowConfiguration.barcodeValue2;
      // const url = workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
      //   ?.concat(BC1)
      //   ?.concat(BC2);

      // const newArrBC = {
      //   ...selectedElement,
      //   elementType: selected,
      //   validation: validation || "",
      //   elementValue: `${url}|${workflowConfigurationStore.WorkflowConfiguration.barcodeType}`,
      //   options: [],
      // };
      if (selected === 'Barcode') {
        // const updatedObj = elemArr?.map((selectedElem) =>
        //   selectedElem.elementId === selectedElement.elementId
        //     ? newArrBC
        //     : selectedElem
        // );
        // const subTaskArr: any = {
        //   // for front end schema
        //   ...selectedSubTasks,
        //   elements: updatedObj,
        // };
        // editSettingsElements(newArrBC);
      } else if (
        selected === 'TextBox' ||
        selected === 'TextArea' ||
        selected === 'ScanArea'
      ) {
        copySelectedElement = {
          ...copySelectedElement,
          validation: validation || '',
        };
      }
      // parent
      else if (selected === 'Parent') {
        copySelectedElement = {
          ...copySelectedElement,
          enableByDefault: true,
        };
      }
    }
    editSettingsElements(copySelectedElement);
    modalStore.closeModal();
    setSelected('');
  };

  const handleClose = () => {
    setSelected('');
    modalStore.closeModal();
  };

  return (
    <>
      {selectedMetaDataElem && (
        <CommonComponentSettings
          isMetadata={true}
          className={'workflowSettingsForm'}
          selectedElement={selectedMetaDataElem}
          elementOptionDetails={elementsNames}
          elementsArray={elementArr || []}
          settingsOptions={metaDataOptions}
          selectedSetting={selected}
          submitClassFunc={() => {}}
          changeSelectOptionHandler={changeSelectOptionHandler}
          handleClose={handleClose}
          handleSave={handleSave}
          scanType={scanType}
        />
      )}
    </>
  );
}

export default observer(MetaDataSettings);
